import controller from './box-products-mini.controller';
import templateDefault from './templates/box-products-mini-default.view.html';
import templateT10 from './templates/box-products-mini-t10.view.html';
import templateT11 from './templates/box-products-mini-t11.view.html';

let BoxProductsMiniComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@',
        itemId: '@',
        categoryId: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {

    let response = SessionService.get('components');
    if (response.BOX_PRODUCTS_MINI.component == 'templateT1') {
        return templateT1
    }
    else if (response.BOX_PRODUCTS_MINI.component == 'template_t10') { return templateT10; }
    else if (response.BOX_PRODUCTS_MINI.component == 'template_t11') { return templateT11; }
    else {
        return templateDefault;
    }
}

export default BoxProductsMiniComponent;



// WEBPACK FOOTER //
// ./www/components/catalog/box-products-mini/box-products-mini.component.js